import { motion } from "framer-motion";
import { ArrowDown, WhatsappLogo } from "@phosphor-icons/react";
import { whatsappLink } from "@/data/site";
import { scrollToSection } from "@/lib/scroll";

const fade = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { delay, duration: 0.7, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => {
  return (
    <section id="inicio" data-testid="hero-section" className="relative min-h-[92vh] flex items-end overflow-hidden bg-black">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=2400&q=80"
          alt="Senderistas caminando hacia montañas nevadas"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/45" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 lg:px-10 pb-20 pt-40">
        <motion.p
          {...fade(0.1)}
          data-testid="hero-eyebrow"
          className="text-sm lg:text-base font-semibold text-white/90 mb-5"
        >
          Ruta 360 | Equipamiento outdoor
        </motion.p>

        <motion.h1
          {...fade(0.25)}
          data-testid="hero-heading"
          className="font-display font-semibold uppercase leading-[0.95] tracking-tight text-5xl sm:text-6xl lg:text-8xl text-white max-w-4xl"
          style={{ textShadow: "0 2px 30px rgba(0,0,0,0.4)" }}
        >
          Equipamiento
          <br />
          para <span className="text-[#FF5508]">explorar más.</span>
        </motion.h1>

        <motion.p {...fade(0.4)} className="mt-6 text-white/75 text-base lg:text-lg leading-relaxed max-w-xl">
          Pesca, ciclismo, camping, kayaks y tecnología para actividades al aire
          libre. Compra en línea con Mercado Pago o PayPal, o pregúntanos por WhatsApp.
        </motion.p>

        <motion.div {...fade(0.55)} className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-start gap-4">
          <button
            data-testid="hero-catalog-cta"
            onClick={() => scrollToSection("equipamiento")}
            className="group inline-flex items-center justify-center gap-3 bg-[#FF5508] text-white text-xs px-8 py-4 rounded-full transition-colors duration-300 hover:bg-white hover:text-black"
          >
            Explorar productos
            <ArrowDown size={16} className="transition-transform duration-300 group-hover:translate-y-1" />
          </button>
          <a
            data-testid="hero-whatsapp-cta"
            href={whatsappLink("Hola Ruta 360, quiero información sobre equipo para mi próxima aventura.")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 border border-white/40 text-white text-xs px-8 py-4 transition-colors duration-300 hover:border-[#25D366] hover:text-[#25D366]"
          >
            <WhatsappLogo size={16} weight="fill" />
            Pregúntanos por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};
